var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.917 2.18934C26.5028 1.60355 27.4526 1.60355 28.0383 2.18934C28.6241 2.77513 28.6241 3.72487 28.0383 4.31066L27.7813 4.5677L25.66 2.44638L25.917 2.18934ZM29.099 1.12868C27.9274 -0.0428934 26.0279 -0.0428931 24.8564 1.12868L24.069 1.91605L23.5387 2.44638L24.069 2.97671L27.251 6.15869L27.7813 6.68902L28.3116 6.15869L29.099 5.37132C30.2706 4.19975 30.2706 2.30025 29.099 1.12868ZM23.0518 3.99393L22.5214 3.4636L21.9911 3.99393L13.7194 12.2656L13.4998 12.4853V12.7959V15.9779V16.7279H14.2498H17.4317H17.7424L17.9621 16.5083L26.2338 8.23657L26.7641 7.70624L26.2338 7.17591L23.0518 3.99393ZM14.9998 15.2279V13.1066L22.5214 5.58492L24.6428 7.70624L17.1211 15.2279H14.9998ZM2 9.74988C2 8.50724 3.00736 7.49988 4.25 7.49988H15.5V5.99988H4.25C2.17893 5.99988 0.5 7.67881 0.5 9.74988V20.2499C0.5 22.3209 2.17893 23.9999 4.25 23.9999H26.75C28.8211 23.9999 30.5 22.3209 30.5 20.2499V8.99988H29V20.2499C29 21.4925 27.9926 22.4999 26.75 22.4999H4.25C3.00736 22.4999 2 21.4925 2 20.2499V9.74988Z",
    fill: "#68728E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.8cdc5f5536428bd01e9177924ad40d34.svg";
export { ForwardRef as ReactComponent };